import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/supreme-logo-1.png"
          width="auto"
          height="100%"
          loading="lazy"
          alt="Supreme Universal"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h1 class="d-block section-heading color-primary text-capitalize">
            About Developer
          </h1>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={() => handleShowModal("AboutDev ChatWithUs")}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Supreme Universal is one of Mumbai’s most prestigious developers,
        renowned for delivering world-class residences with premium
        craftsmanship, superior architecture, and modern lifestyle amenities.
        With a legacy of excellence in luxury real estate, Supreme Boulevard
        Chembur is designed to set a new benchmark in urban resort living.
      </p>

      <div class="rera-numbers">
        <div class="rera-item">
          <img src="images/rera-PR1180002400026.jpeg" alt="rera qr" />
          <strong>PR1180002400026</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("AboutDev ChatWithUs")}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
